<template>
	<div class="section-steps">
		<div class="container">
			<div>
				<h4 class="step-title mb-4 bold">TE MOSTRAMOS <br/>CÓMO FUNCIONA</h4>
				<p class="stpe-text">Amigo bodeguero, te queremos mostrar lo sencillo que es usar Mibodega; prepárate para 
					añadir a tu negocio una potente herramienta de tecnología:
				</p>
			</div>
			<v-layout wrap class="steps-wrapper-images">
				<v-flex xs10 md3 class="wrapper-group">
					<img 
						:src="`${$S3}step-1.png`" 
						alt="paso 1"
						class="step-image">
					<div class="wrapper-number">
						<span class="step-number bold">1</span>
						<hr class="step-line" />
					</div>
					<p class="mb-0 step-text">Tu cliente se descarga tu aplicativo</p>
				</v-flex>
				<v-flex xs10 md3 class="wrapper-group">
					<img 
						:src="`${$S3}step-2.png`" 
						alt="paso 2"
						class="step-image">
					<div class="wrapper-number">
						<span class="step-number bold">2</span>
						<hr class="step-line" />
					</div>
					<p class="mb-0 step-text">Tu cliente realiza el pedido y escoge el tipo de entrega.</p>
				</v-flex>
				<v-flex xs10 md3 class="wrapper-group">
					<img 
						:src="`${$S3}step-3.png`" 
						alt="paso 3"
						class="step-image">
					<div class="wrapper-number">
						<span class="step-number bold">3</span>
						<hr class="step-line" />
					</div>
					<p class="mb-0 step-text">Recibes el pedido y lo preparas</p>
				</v-flex>
				<v-flex xs10 md3 class="wrapper-group">
					<img 
						:src="`${$S3}step-4.png`" 
						alt="paso 4"
						class="step-image">
					<div class="wrapper-number">
						<span class="step-number bold">4</span>
						<hr class="step-line mobile"/>
					</div>
					<p class="mb-0 step-text">Pedido listo para entrega.</p>
				</v-flex>
			</v-layout>
			<div class="wrapper-btn">
				<a class="btn-step bold" href="#banner">Solicita tu app</a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'section-steps',
};
</script>
<style lang="scss" scoped>
	.section-steps {
		background-color: map-get($colors, back-gray-l);
		color: map-get($colors, form-grey);
		font-family: font(lato-regular);
		padding: 65px 7% 92px;

		@media (max-width: 936px) {
			padding: 40px 0 50px;
		}

		@media (min-width: 1350px) {
			padding: 65px 0 92px;
		}
	}

	.step-image {
		height: 169px;
	}

	.step-title {
		color: map-get($colors, green-dark);
		font-size: map-get($sizes, large34);

		@media (max-width: 936px) {
			font-size: map-get($sizes, large30);
			text-align: center;
		}
	}

	.stpe-text {
		margin-bottom: 60px;
		font-size: map-get($sizes, medium18);
		width: 40%;

		@media (max-width: 936px) {
			margin-bottom: 50px;
			padding: 0 6%;
			text-align: center;
			width: 100%;
		}
	}

	.step-line {
		border: 2px solid map-get($colors, back-green);
		position: absolute;
		right: 0;
		top: 36px;
		width: calc(100% - 30px);
	}

	.wrapper-number {
		height: 40px;
		margin-bottom: 31px;
		position: relative;
	}

	.step-number {
		color: map-get($colors, title-green);
		font-size: map-get($sizes, large48);
		position: absolute;
	}

	.step-text {
		color: map-get($colors, form-grey);
		font-size: map-get($sizes, medium20);
	}

	.btn-step {
		background-color: map-get($colors, back-green);
		border-radius: 9px;
		color: map-get($colors, white);
		display: inline-block;
		font-size: map-get($sizes, medium18);
		padding: 15px 0;
		text-decoration: none;
		width: 227px;
	}

	.wrapper-btn {
		margin-top: 68px;
		text-align: center;
	}

	.steps-wrapper-images {
		@media (max-width: 936px) {
			justify-content: flex-end;
		}
	}

	.wrapper-group {
		padding-right: 16px;

		@media (max-width: 936px) {
			margin-bottom: 30px;
			padding-right: 0;
		}
	}

	.mobile {
		display: none;

		@media (max-width: 936px) {
			display: block;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-steps.vue